(function () {
  var mapsScriptPromise = null;

  function encodeQuery(value) {
    return encodeURIComponent(String(value || '')).replace(/%20/g, '+');
  }

  function buildEmbedUrl(query, zoom) {
    return (
      'https://maps.google.com/maps?q=' +
      encodeQuery(query) +
      '&z=' +
      (zoom || 17) +
      '&ie=UTF8&output=embed'
    );
  }

  function buildCoordEmbedUrl(lat, lng, zoom) {
    return (
      'https://maps.google.com/maps?q=' +
      encodeQuery(lat + ',' + lng) +
      '&ll=' +
      encodeQuery(lat + ',' + lng) +
      '&z=' +
      (zoom || 17) +
      '&ie=UTF8&output=embed'
    );
  }

  function collectStores(storeButtons) {
    return storeButtons.map(function (btn) {
      return {
        id: btn.getAttribute('data-store-id'),
        name: btn.getAttribute('data-store-name') || '',
        address: btn.getAttribute('data-store-address') || '',
        lat: parseFloat(btn.getAttribute('data-store-lat')),
        lng: parseFloat(btn.getAttribute('data-store-lng')),
        button: btn,
      };
    });
  }

  function storeQuery(store) {
    if (store.name && store.address) return store.name + ', ' + store.address;
    return store.address || store.name || 'Hong Kong';
  }

  function loadGoogleMaps(apiKey) {
    if (window.google && window.google.maps) {
      return Promise.resolve(window.google.maps);
    }
    if (mapsScriptPromise) return mapsScriptPromise;

    mapsScriptPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(apiKey) +
        '&v=weekly';
      script.async = true;
      script.defer = true;
      script.onload = function () {
        if (window.google && window.google.maps) resolve(window.google.maps);
        else reject(new Error('Google Maps failed to load'));
      };
      script.onerror = function () {
        mapsScriptPromise = null;
        reject(new Error('Google Maps script error'));
      };
      document.head.appendChild(script);
    });

    return mapsScriptPromise;
  }

  function pinIcon(maps, active) {
    var size = active ? 36 : 22;
    var fill = active ? '#5f612d' : '#989a5f';
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="' +
      size +
      '" height="' +
      (size + 10) +
      '" viewBox="0 0 24 34">' +
      '<path fill="' +
      fill +
      '" stroke="#ffffff" stroke-width="2" d="M12 1C6.5 1 2 5.5 2 11c0 7.5 10 21 10 21s10-13.5 10-21C22 5.5 17.5 1 12 1z"/>' +
      '<circle cx="12" cy="11" r="3.5" fill="#ffffff"/>' +
      '</svg>';

    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new maps.Size(size, size + 10),
      anchor: new maps.Point(size / 2, size + 10),
    };
  }

  function initJsMap(root, mapEl, stores, setActiveCard) {
    var apiKey = root.getAttribute('data-maps-api-key') || '';
    if (!apiKey || !mapEl || !stores.length) return Promise.resolve(false);

    return loadGoogleMaps(apiKey)
      .then(function (maps) {
        var markersById = {};
        var infoWindowsById = {};
        var bounds = new maps.LatLngBounds();
        var validStores = stores.filter(function (store) {
          return !isNaN(store.lat) && !isNaN(store.lng);
        });

        if (!validStores.length) return false;

        validStores.forEach(function (store) {
          bounds.extend({ lat: store.lat, lng: store.lng });
        });

        var map = new maps.Map(mapEl, {
          center: bounds.getCenter(),
          zoom: 12,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: true,
          zoomControl: true,
          clickableIcons: false,
          styles: [
            {
              featureType: 'poi',
              stylers: [{ visibility: 'off' }],
            },
          ],
        });

        map.fitBounds(bounds, 48);

        validStores.forEach(function (store) {
          var marker = new maps.Marker({
            map: map,
            position: { lat: store.lat, lng: store.lng },
            title: store.name,
            icon: pinIcon(maps, false),
            optimized: false,
          });

          var info = new maps.InfoWindow({
            content:
              '<div style="font:600 13px/18px \'Hanken Grotesk\',sans-serif;color:#1c1b1b;max-width:200px;">' +
              store.name.replace(/</g, '&lt;') +
              '</div><div style="font:400 12px/18px \'Hanken Grotesk\',sans-serif;color:#48473b;margin-top:4px;max-width:200px;">' +
              store.address.replace(/</g, '&lt;') +
              '</div>',
          });

          marker.addListener('click', function () {
            setActiveCard(store.id, true);
          });

          markersById[store.id] = marker;
          infoWindowsById[store.id] = info;
        });

        root._bbSlMap = {
          mode: 'js',
          map: map,
          maps: maps,
          markersById: markersById,
          infoWindowsById: infoWindowsById,
          bounds: bounds,
        };

        mapEl.setAttribute('data-map-ready', 'true');
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function focusJsStore(root, storeId) {
    var state = root._bbSlMap;
    if (!state || state.mode !== 'js') return;

    Object.keys(state.markersById).forEach(function (id) {
      var marker = state.markersById[id];
      var active = id === storeId;
      marker.setIcon(pinIcon(state.maps, active));
      marker.setZIndex(active ? 999 : 1);
      if (!active && state.infoWindowsById[id]) {
        state.infoWindowsById[id].close();
      }
    });

    var activeMarker = state.markersById[storeId];
    var activeInfo = state.infoWindowsById[storeId];
    if (!activeMarker) return;

    state.map.panTo(activeMarker.getPosition());
    if (state.map.getZoom() < 15) state.map.setZoom(16);
    if (activeInfo) activeInfo.open({ map: state.map, anchor: activeMarker });
  }

  function focusEmbedStore(iframe, store) {
    if (!iframe || !store) return;
    if (!isNaN(store.lat) && !isNaN(store.lng)) {
      iframe.src = buildCoordEmbedUrl(store.lat, store.lng, 17);
    } else {
      iframe.src = buildEmbedUrl(storeQuery(store), 17);
    }
    iframe.title = store.name || iframe.title;
  }

  function initStoreLocator(root) {
    if (!root || root.dataset.bbSlReady === 'true') return;
    root.dataset.bbSlReady = 'true';

    var storeButtons = Array.prototype.slice
      .call(root.querySelectorAll('[data-store-id]'))
      .filter(function (el) {
        return el.classList.contains('bb-store-locator__store-btn');
      });
    var stores = collectStores(storeButtons);
    var mapEl = root.querySelector('[data-sl-map]');
    var iframe = root.querySelector('[data-sl-side-embed]');
    var apiKey = (root.getAttribute('data-maps-api-key') || '').trim();

    function setActive(storeId, scrollCard) {
      storeButtons.forEach(function (btn) {
        var active = btn.getAttribute('data-store-id') === storeId;
        btn.classList.toggle('is-selected', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && scrollCard) {
          btn.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      });

      var selected = stores.find(function (store) {
        return store.id === storeId;
      });

      if (root._bbSlMap && root._bbSlMap.mode === 'js') {
        focusJsStore(root, storeId);
      } else if (iframe && selected) {
        focusEmbedStore(iframe, selected);
      }
    }

    storeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActive(btn.getAttribute('data-store-id'), false);
      });
    });

    function finishBoot() {
      if (storeButtons.length) {
        setActive(storeButtons[0].getAttribute('data-store-id'), false);
      }
    }

    if (apiKey && mapEl) {
      if (iframe) iframe.hidden = true;
      mapEl.hidden = false;
      initJsMap(root, mapEl, stores, setActive).then(function (ok) {
        if (!ok) {
          mapEl.hidden = true;
          if (iframe) iframe.hidden = false;
        }
        finishBoot();
      });
    } else {
      if (mapEl) mapEl.hidden = true;
      if (iframe) iframe.hidden = false;
      finishBoot();
    }
  }

  function boot() {
    document
      .querySelectorAll('[data-bb-store-locator]')
      .forEach(initStoreLocator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector('[data-bb-store-locator]');
    if (root) {
      root.dataset.bbSlReady = 'false';
      root._bbSlMap = null;
      initStoreLocator(root);
    }
  });
})();
